const enMessages = {
  common: {
    dashboard: "Dashboard",
    edit: "Edit",
    account: "Account",
    one_off: "One Off Request",
    replacement: "Replacement",
    parts: "Parts",
    refund: "Refund",
    refresh: "Refresh",
    devices: "Devices",
    device: "Device",
    requests: "Requests",
    history: "History",
    back_to_search: "Back to main search",
    view_all: "View all",
    mac_address: "Mac Address",
    timezone_updated: "Timezone updated successfully",
    language_updated: "Language updated successfully",
    event: "Event",
  },
  locations: {
    title: "Locations",
    refresh: "Refresh",
  },
  diagnostics: {
    title: "Diagnostics",
  },
  devices: {
    title: "All Devices",
  },
  history: {
    title: "History",
    events: "Events",
    status_reports: "Summary Reports",
    setups: "Setups",
  },
  events: {
    title: "Events",
  },
  status_reports: {
    title: "Status Reports",
  },
  setups: {
    title: "Setups",
  },
  authorizations: {
    title: "Authorizations",
  },
  device_ownership: {
    title: "Device Ownership",
  },
  customer_transfers: {
    title: "Customer's device transfers",
  },
  requests: {
    search: "Search & Filter",
    title: "Requests",
    refresh: "Refresh",
    list: "Go to list",
    uuid: "UUID",
    type: "Type",
    product: "Product",
    old_product: "Old Product",
    kind: "Kind",
    created: "Created at",
    status: "State",
    device_id: "Device id",
    old_device_id: "Old Device",
    agent: "Agent",
    tracking_id: "Tracking id",
    address: "Customer Address",
    types: {
      replacement: "Replacement",
      oneoff: "One Off",
      refund: "Refund",
      part: "Parts",
    },
    states: {
      pending: "Pending",
      canceled: "Cancelled",
      shipped: "Shipped",
      closed: "Closed",
      resolved: "Resolved",
    },
  },
  details: {
    title: "General Details",
    full_name: "Full Name",
    created_at: "Created At",
    devices_connected: "Client devices",
    secondary_email: "Secondary Email",
    primary_email: "Primary Email",
    phone: "Phone Number",
    referrals: "Referrals",
    reset_password: "Reset Password",
    account_type: "Account Type",
  },
  client_devices: {
    title: "Client Devices",
    app_brand: "Brand",
    hardware_id: "Hardware ID",
    os: "Operating System",
    signed_in: "Signed In",
    allows_screensharing: "Screensharing",
  },
  customer_authorizations: {
    title: "Authorizations",
    auth_type: "Type",
    created_at: "Created",
    requested_by: "Requested By",
    status: "Status",
  },
  payment_history: {
    date: "Date",
    provider: "Provider",
    type: "Type",
    amount: "Amount",
    currency: "Currency",
    paid: "Captured",
    refunded: "Refunded",
    card_brand: "Type",
    credit_card: "CCard",
    status: "Status",
  },
  device: {
    title: "Device",
    general: "General",
    settings: "Settings",
    events: "Events",
    status_reports: "Summary Reports",
    notes_tags: "Notes/Tags",
    authorizations: "Authorizations",
    schedules: "Schedules",
  },
};

export default enMessages;
